import React, { useEffect, useState } from "react";
import { DashboardLayout } from "../../components/dashboard/DashboardLayout";
import { PageHeader } from "../../components/dashboard/UI";
import { useI18n } from "../../i18n/I18nContext";
import { api } from "../../lib/api";
import { Download, FileText, FileLock2, FileBadge, BookOpen, FileCog, ScrollText, ClipboardList } from "lucide-react";

const ICON = {
  contract: FileLock2, audit: FileBadge, manual: BookOpen,
  as_built: ScrollText, firmware: FileCog, report: FileText,
  maintenance_log: ClipboardList,
};

const TYPE_LABEL = {
  contract: "Contract", audit: "Audit", manual: "Manual",
  as_built: "As-Built", firmware: "Firmware", report: "Report",
  maintenance_log: "Maintenance Log",
};

const Documents = () => {
  const { t } = useI18n();
  const [docs, setDocs] = useState([]);

  useEffect(() => {
    api.get("/documents").then((r) => setDocs(r.data)).catch(() => setDocs([]));
  }, []);

  return (
    <DashboardLayout>
      <PageHeader eyebrow={t("dashboard.summary")} title={t("dashboard.documents")} />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {docs.map((d) => {
          const Icon = ICON[d.type] || FileText;
          return (
            <article key={d.id} className="card-sharp p-5 flex items-start gap-4" data-testid={`doc-${d.id}`}>
              <div className="w-10 h-10 flex-shrink-0 bg-[#19A7E0]/10 border border-[#19A7E0]/20 rounded-sm flex items-center justify-center">
                <Icon className="w-5 h-5 text-[#19A7E0]" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-[10px] font-mono uppercase tracking-[0.2em] text-white/40">
                  {TYPE_LABEL[d.type]} · {(d.size_kb / 1024).toFixed(1)} MB
                </p>
                <p className="mt-1 text-sm font-medium truncate">{d.name}</p>
                <p className="text-[10px] font-mono text-white/40 mt-1">
                  {t("dashboard.uploaded")}: {new Date(d.uploaded_at).toLocaleDateString()}
                </p>
              </div>
              <button
                onClick={(e) => e.preventDefault()}
                data-testid={`doc-download-${d.id}`}
                className="btn-ghost px-3 py-2 text-[11px] font-mono uppercase tracking-[0.18em] rounded-sm inline-flex items-center gap-1.5"
              >
                <Download className="w-3.5 h-3.5" />
              </button>
            </article>
          );
        })}
        {docs.length === 0 && <p className="text-sm text-white/50">{t("dashboard.noData")}</p>}
      </div>
    </DashboardLayout>
  );
};

export default Documents;
